import React, { Component, useState, useEffect } from "react";
import apiService from '../../../config';

const Parishtisht_B = () => {
    const [tableRows, setTableRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [editState, setEditState] = useState({});

    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProposalId, setCurrentProposalId] = useState(null);
    const [currentProjectName, setCurrentProjectName] = useState(null);

    // Project Id
    useEffect(() => {
        const getProjectInfo = () => {
            const currentProjectData = localStorage.getItem('currentProjectData');
            if (currentProjectData) {
                try {
                    const projectData = JSON.parse(currentProjectData);
                    return {
                        id: projectData.project_id || projectData.id,
                        name: projectData.project_name || projectData.name
                    };
                } catch (e) {
                    console.error('Error parsing currentProjectData:', e);
                }
            }
            const selectedProject = localStorage.getItem('selectedProject');
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return {
                        id: project.project_id || project.id,
                        name: project.project_name || project.name
                    };
                } catch (e) {
                    console.error('Error parsing selectedProject:', e);
                }
            }
            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    return {
                        id: user.data?.project_id || user.project_id,
                        name: user.data?.project_name || user.project_name || 'Unknown Project'
                    };
                } catch (e) {
                    console.error('Error parsing userData:', e);
                }
            }
            return { id: null, name: null };
        };
        const projectInfo = getProjectInfo();
        setCurrentProjectId(projectInfo.id);
        setCurrentProjectName(projectInfo.name);
    }, []);

    // Proposal Id
    useEffect(() => {
        const getProposalInfo = () => {
            const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');
            if (currentProposal) {
                try {
                    return {
                        proposalId: currentProposal?.data?.default_proposal ||
                            currentProposal?.data?.proposal_id ||
                            currentProposal?.default_proposal ||
                            currentProposal?.proposal_id ||
                            null
                    };
                } catch (e) {
                    console.error('Error parsing getProposalInfo:', e);
                }
            }
            return { proposalId: null };
        };
        const proposalInfo = getProposalInfo();
        setCurrentProposalId(proposalInfo.proposalId);
    }, []);

    // Fetch land holding data
    useEffect(() => {
        if (!currentProjectId || !currentProposalId) return;

        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await apiService.getRailwayLandHolding(currentProjectId, {
                    proposalId: currentProposalId
                });

                const landData = response?.data || [];

                const rows = landData.map((parcel, index) => {
                    const owners = parcel.owners || [];
                    const totalOwnerArea = owners.reduce((sum, o) => sum + (parseFloat(o.owner_total_area) || 0), 0);
                    const totalAcquiredArea = owners.reduce((sum, o) => sum + (parseFloat(o.owner_aqr_area) || 0), 0);

                    return {
                        sr: index + 1,
                        landId: parcel.LandAcquisition_id,
                        village: parcel.village_name || "-",
                        gat: parcel.survey_no || "-",
                        totalArea: totalOwnerArea.toFixed(2),
                        acquiredArea: parcel.prishist_B_additional_acquired_area || "",
                        remark: parcel.prishist_B_remarks || ""
                    };
                });

                setTableRows(rows);
            } catch (err) {
                console.error('Error fetching land holding data:', err);
                setError('माहिती लोड करताना त्रुटी आली.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [currentProjectId, currentProposalId]);

    // Start editing a row
    const handleEdit = (index, row) => {
        setEditState(prev => ({
            ...prev,
            [index]: {
                acquiredArea: row.acquiredArea,
                remark: row.remark
            }
        }));
    };

    // Handle input change
    const handleChange = (index, field, value) => {
        setEditState(prev => ({
            ...prev,
            [index]: {
                ...prev[index],
                [field]: value
            }
        }));
    };

    // Save edited row
    const handleSave = async (index, landId) => {
        const edited = editState[index];
        if (!edited) return;

        try {
            await apiService.updateRailwayLandHolding(landId, {
                prishist_B_additional_acquired_area: edited.acquiredArea,
                prishist_B_remarks: edited.remark
            });

            setTableRows(prev => prev.map((r, i) =>
                i === index ? { ...r, acquiredArea: edited.acquiredArea, remark: edited.remark } : r
            ));

            setEditState(prev => {
                const next = { ...prev };
                delete next[index];
                return next;
            });
        } catch (err) {
            console.error('Error updating land holding:', err);
            alert('अपडेट करताना त्रुटी आली.');
        }
    };

    // Cancel editing
    const handleCancel = (index) => {
        setEditState(prev => {
            const next = { ...prev };
            delete next[index];
            return next;
        });
    };

    return (
        <div className="bg-white text-black p-6">
            {/* Heading */}
            <div className="text-center mt-6">
                <h2 className="font-semibold">परिशिष्ट 'ब'</h2>
                <p className="text-sm mt-1">
                    सरकारी जमिनी संपादन प्रस्ताव क्षेत्राच्या संबंधित माहिती दर्शविणारा तक्ता
                </p>
            </div>

            {/* Loading / Error */}
            {loading && <p className="text-center mt-4 text-blue-600">लोड होत आहे...</p>}
            {error && <p className="text-center mt-4 text-red-600">{error}</p>}

            {/* Table */}
            <div className="mt-6 overflow-x-auto">
                <table className="w-full border border-black border-collapse text-sm">
                    <thead>
                        <tr>
                            <th className="border border-black p-2">अ. क्र.</th>
                            <th className="border border-black p-2">गावाचे नाव</th>
                            <th className="border border-black p-2">गट नंबर</th>
                            <th className="border border-black p-2">
                                संपादित एकूण क्षेत्र <br />(हेक्टर-आर-गुंठे)
                            </th>
                            <th className="border border-black p-2">
                                कामासाठी लागणारी <br />अतिरिक्त संपादित क्षेत्र
                            </th>
                            <th className="border border-black p-2">शेरा</th>
                            <th className="border border-black p-2">क्रिया</th>
                        </tr>
                    </thead>

                    <tbody>
                        {tableRows.map((row, index) => {
                            const isEditing = !!editState[index];
                            return (
                                <tr key={index}>
                                    <td className="border border-black p-2 text-center">{row.sr}</td>
                                    <td className="border border-black p-2">{row.village}</td>
                                    <td className="border border-black p-2 text-center">{row.gat}</td>
                                    <td className="border border-black p-2 text-center font-semibold">{row.totalArea}</td>

                                    {/* Editable: अतिरिक्त संपादित क्षेत्र */}
                                    <td className="border border-black p-2 text-center">
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                value={editState[index].acquiredArea}
                                                onChange={(e) => handleChange(index, 'acquiredArea', e.target.value)}
                                                className="border border-gray-400 rounded px-1 py-0.5 w-full text-center text-sm"
                                            />
                                        ) : (
                                            row.acquiredArea || "-"
                                        )}
                                    </td>

                                    {/* Editable: शेरा */}
                                    <td className="border border-black p-2">
                                        {isEditing ? (
                                            <input
                                                type="text"
                                                value={editState[index].remark}
                                                onChange={(e) => handleChange(index, 'remark', e.target.value)}
                                                className="border border-gray-400 rounded px-1 py-0.5 w-full text-sm"
                                            />
                                        ) : (
                                            row.remark || "-"
                                        )}
                                    </td>

                                    {/* Action buttons */}
                                    <td className="border border-black p-2 text-center">
                                        {isEditing ? (
                                            <div className="flex gap-1 justify-center">
                                                <button
                                                    onClick={() => handleSave(index, row.landId)}
                                                    className="bg-green-600 text-white px-2 py-0.5 rounded text-xs hover:bg-green-700"
                                                >
                                                    जतन
                                                </button>
                                                <button
                                                    onClick={() => handleCancel(index)}
                                                    className="bg-gray-400 text-white px-2 py-0.5 rounded text-xs hover:bg-gray-500"
                                                >
                                                    रद्द
                                                </button>
                                            </div>
                                        ) : (
                                            <button
                                                onClick={() => handleEdit(index, row)}
                                                className="bg-blue-600 text-white px-2 py-0.5 rounded text-xs hover:bg-blue-700"
                                            >
                                                संपादित
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}


                    </tbody>
                </table>
            </div>

            {/* Footer */}
            <div className="mt-10 text-center text-sm">
                <p>
                    उपकार्यकारी अभियंता, (बांधकाम विभाग), <br />
                    दक्षिण मध्य रेल्वे, अकोला
                </p>
            </div>
        </div>
    );
};

export default Parishtisht_B;